import React from 'react';

const TrashChunkySvg = (props) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7 19h10V8H7v11zM18 5h-3l-1-1h-4L9 5H6v2h12z"
        />
    </svg>
);

TrashChunkySvg.displayName = 'TrashChunkySvg';
export default TrashChunkySvg;
